<template>
  <div class="page-wrapper">
    <el-form :model="ruleForm"  ref="ruleForm" :rules="rules" label-width="120px">
      <div class="cg-mod-title">抖音订单导入</div>
      <div class="cg-form-mod">
        <el-form-item label="供应商id：" prop="supplierUserId">
          <el-input size="small" class="w36" v-model="ruleForm.supplierUserId" placeholder="请输入或选择供应商id"></el-input>
          <el-button size="small" type="primary" plain @click="openSupplierPop(1)">选择</el-button>
        </el-form-item>
        <el-form-item label="销售商id：" prop="dealerUserId">
          <el-input size="small" class="w36" v-model="ruleForm.dealerUserId" placeholder="请输入或选择销售商id"></el-input>
          <el-button size="small" type="primary" plain @click="openSupplierPop(2)">选择</el-button>
        </el-form-item>
        <el-form-item label="场次：" prop="orderRemark">
          <el-input size="small" class="w36" v-model="ruleForm.orderRemark" placeholder="请输入或选择场次"></el-input>
          <el-button size="small" type="primary" plain @click="openTimePop">选择</el-button>
        </el-form-item>
        <el-form-item label="品牌名：" prop="brand">
          <el-input size="small" class="w36" v-model="ruleForm.brand" placeholder="请输入或选择品牌名"></el-input>
          <el-button size="small" type="primary" plain @click="openBrandPop">选择</el-button>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="openUploadPop">上传文件</el-button>
        </el-form-item>
      </div>
    </el-form>

    <el-dialog
      :title="slecetSupplierType == 1 ? '选择供应商': '选择销售商'"
      :visible.sync="selectSupplierPop"
      width="800px"
    > 
      <div class="search-box">
        <el-form :inline="true">
          <el-form-item>
              <el-input size="small" placeholder="请输入销售商/供应商名字"
                v-model="searchObj.fuzzyQuery"
                clearable
                @clear="clearSearchHandle"
              ></el-input>
          </el-form-item>
          <el-form-item>
              <el-button size="small" icon="el-icon-search" type="primary" @click="fuzzySearchClick">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table v-loading="tableLoading" :data="tableData">
        <el-table-column label="用户名/公司名" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.user_individual_name">
              <span class="nameSpan"> {{ scope.row.user_individual_name }} </span><br>
              <el-tag type="danger" size="mini">个人</el-tag>
            </div>
            <div v-if="scope.row.user_organization_name">
              <span class="nameSpan">{{ scope.row.user_organization_name }}</span><br>
              <el-tag type="success" size="mini">公司</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="身份" width="60">
          <template slot-scope="scope">
            <el-tag type="warning" size="mini" v-if="scope.row.user_initial_type==2" effect="dark">销售商</el-tag>
            <el-tag type="success" size="mini" v-if="scope.row.user_initial_type==1" effect="dark">供应商</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="用户ID" width="80">
            <template slot-scope="scope">{{ scope.row.user_id }}</template>
        </el-table-column>
        <el-table-column label="用户手机" width="120">
          <template slot-scope="scope">{{ scope.row.user_cellphone }}</template>
        </el-table-column>

        <el-table-column label="联系人/手机号">
          <template slot-scope="scope">
            <div>
              {{ scope.row.user_contact_person }} <br>
              {{ scope.row.user_contact_cellphone }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag type="success" size="mini" v-if="scope.row.user_state == 'y'">通过</el-tag>
            <el-tag type="warning" size="mini" v-if="scope.row.user_state == 'p'">待审核</el-tag>
            <el-tag type="danger" size="mini" v-if="scope.row.user_state == 'n'">被拒绝</el-tag>
          </template>
        </el-table-column>


        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="selectUserIdHandle(scope)">选择</el-button>
          </template>
        </el-table-column> 
      </el-table>

      <div class="page-wrap">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="searchObj.page"
          :page-size.sync="searchObj.num" layout="total, sizes, prev, pager, next, jumper" :total="total" background>
        </el-pagination>
      </div>
      
    </el-dialog>

    <el-dialog
      title="选择场次"
      :visible.sync="selectTimePop"
      width="600px"
    > 
      <div class="time-list-wrap">
        <div class="no-data" v-if="TimeList.length == 0">
          抱歉，暂无场次信息，请手动输入
        </div>
        <div class="time-list" v-else>
            <el-tag
              v-for="(item, index) in TimeList"
              class="time-tag"
              :key="index"
              type="success"
              effect="plain"
              @click="selectTimeHandle(item)"
            >
              {{ item }}
            </el-tag>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="选择品牌"
      :visible.sync="selectBrandPop"
      width="600px"
    > 
      <div class="time-list-wrap">
        <div class="no-data" v-if="BrandList.length == 0">
          抱歉，暂无品牌信息，请手动输入
        </div>
        <div class="time-list" v-else>
            <el-tag
              v-for="(item, index) in BrandList"
              class="time-tag"
              :key="index"
              type="success"
              effect="plain"
              @click="selectBrandHandle(item)"
            >
              {{ item.item_display_name }}
            </el-tag>
        </div>
      </div>
    </el-dialog>

    <el-dialog
        title="上传表格"
        :visible.sync="uploadPop"
        width="600px"
        :close-on-click-modal="false"
        class="upload-stock-pop"
    >
        <el-upload
            class="upload-stock"
            drag
            name="file"
            :action="uploadFileApi"
            :data="uploadData"
            :show-file-list="false"
            accept=".xlsx,.xls"
            :on-progress="onProgress"
            :on-success="uploadSuccess"
            :on-error="uploadFail"
            :before-upload="beforeUpload"
        >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">
                只能上传excel文件
                <!-- , 上传模板示例下载： -->
                <!-- <a :href="uploadExampleLink">库存修改上传表格-模板.xlsx</a> -->
            </div>
        </el-upload>
        <div class="progress-wrap" v-if="uploadLoading">
            <div class="progress-bar" v-show="uploadProgress<=100">
              <div class="progress-bar-inner" :style="{width: uploadProgress + '%'}"></div>
            </div>
            <div class="loading-wrap" v-show="uploadProgress > 100">
              <i class="el-icon-loading"></i>
            </div>
            <div class="text">{{uploadText}}</div>
            <div class="text" v-show="waitT">您已等候: {{waitT}}, 请继续坚持，加油哦~</div>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { importApi, ajaxImport} from '@/common/request_import.js'
import { ajaxPost } from '@/common/request.js'
import { setInterval } from 'timers';
export default {
  components: {

  },
  computed: {
  
  },
  data() {
    return {
      ruleForm: {
        supplierUserId: '',
        dealerUserId: '',
        orderRemark: '',
        brand: '',
      },
      rules: {
        supplierUserId: [
          { required: true, message: '请输入或选择供应商id', trigger: 'change' },
        ],
        dealerUserId: [
          { required: true, message: '请输入或选择销售商id', trigger: 'change' }
        ],
        orderRemark: [
          { required: true, message: '请输入或选择场次', trigger: 'change' }
        ],
        brand: [
          { required: true, message: '请输入或选择品牌名', trigger: 'change' }
        ],
      },
      // 选择场次
      selectTimePop: false,
      TimeList: [],

      // 选择品牌
      selectBrandPop: false,
      BrandList: [],

      // 上传相关
      uploadPop: false,
      uploadFileApi: importApi + '/file_service/douyin/file/readOrderData',
      uploadData: {
        supplierUserId: '', // '442',
        orderRemark: '', // '202012021148上传',
        brand: '',       // '测试品牌1',
        dealerUserId: '', // '5387'
      },
      uploadLoading: false,
      uploadProgress: 0,
      uploadText: '正在上传...',
      waitT: '',
      startT: 0,
      waitTimer: null,


      // 用户列表
      slecetSupplierType: 1, // 1 - 选择供应商  2 - 选择销售商
      selectSupplierPop: false,
      tableLoading: false,
      searchObj: {
        fuzzyQuery: '',
        page: 1,
        num: 10,
      },
      total: 0,
      //表格
      tableData: [],
    };
  },
  watch: {},
  created() {

  },
  methods: {
    // 选择供应商
    openSupplierPop(type) {
      this.slecetSupplierType = type; 
      this.selectSupplierPop = true;
      this.getTableLists();
    },
    getTableLists() {
      let _this = this
      this.tableLoading = true
      this.tableData = []
      let arg={
        fuzzyQuery: this.searchObj.fuzzyQuery,
        page: this.searchObj.page,
        num: this.searchObj.num,
      }
      ajaxPost('/admin/userList', arg).then((res) => {
        if (res.errorCode == 200) {
          this.total = parseInt(res.data.userCount)
          this.tableData = res.data.userList
        } else {
          this.$message.error(res.errorMsg || '获取数据失败');
        }
      }).finally(() => {
        this.tableLoading = false
      })
    },
    handleSizeChange(size) {
      this.searchObj.num = size
      this.searchObj.page = 1
      this.getTableLists()
    },
    handleCurrentChange(page) {
      this.searchObj.page = page
      this.getTableLists()
    },
    fuzzySearchClick() {
      this.searchObj.page = 1;
      this.getTableLists()
    },
    clearSearchHandle() {
      this.searchObj.page = 1;
      this.getTableLists()
    },
    selectUserIdHandle(scope) {
      if (this.slecetSupplierType == 1) {
        this.ruleForm.supplierUserId = scope.row.user_id
      }
      if (this.slecetSupplierType == 2) {
        this.ruleForm.dealerUserId = scope.row.user_id
      }
      this.selectSupplierPop = false;
    },

    // 选择场次
    openTimePop() {
      if (this.ruleForm.supplierUserId == '' || this.ruleForm.dealerUserId == '') {
        this.$message.error('请先填写供应商ID和销售商ID');
        return;
      }
      this.selectTimePop = true;
      this.TimeList = [];
      this.selectTimeApi();
    },
    selectTimeApi() {
      ajaxImport('/file_service/douyin/file/getRemark', {
        "dealerUserId": this.ruleForm.dealerUserId, // "5387",
        "supplierUserId": this.ruleForm.supplierUserId // "442"
      }).then(res => {
        console.log(res)
        if (res.errorCode == 200) {
          if (res.data && res.data.order_remark) {
            this.TimeList = res.data.order_remark.split(',');
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    selectTimeHandle(item) {
      this.ruleForm.orderRemark = item;
      this.selectTimePop = false;
    },

    // 选择品牌
    openBrandPop () {
      if (this.ruleForm.supplierUserId == '') {
        this.$message.error('请先填写供应商ID');
        return;
      }
      this.selectBrandPop = true;
      this.BrandList = [];
      this.requestBrandList();
    },
    requestBrandList() {
      ajaxPost('/commodity/brandListByUser', {
        userId: this.ruleForm.supplierUserId
      }).then(res => {
        console.log(res)
        if (res.errorCode == 200) {
          if (res.data && Array.isArray(res.data)) {
            this.BrandList = res.data;
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    selectBrandHandle(item) {
      this.ruleForm.brand = item.item_display_name;
      this.selectBrandPop = false;
    },

    // 上传表格
    openUploadPop() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.uploadData = {
            ...this.ruleForm
          };
          this.uploadPop = true;
        }
      });
        
    },
    beforeUpload(file) {
        console.log(file);

        const isExcel = file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        || file.type == 'application/vnd.ms-excel';
        const isLimit = file.size / 1024 / 1024 < 100;
        if (!isExcel) {
            this.$message.error("请上传Excel格式的文件!");
            return false
        }
        if (!isLimit) {
            this.$message.error("上传Excel大小不能超过 100MB!");
            return false
        }
        this.uploadLoading = true
        this.uploadProgress = 0
        this.uploadText = '正在上传...'
        this.waitT = ''
        return isExcel && isLimit;
    },
    onProgress(e, file, fileList) {
        console.log(e, file, fileList)
        this.uploadProgress = e.percent
        if (e.percent >= 100) {
          this.uploadProgress = 101
          this.waitT = '';
          this.uploadText = '上传完成，数据正在处理中，请耐心等待...'
          this.startT = new Date().getTime();
          this.countWaitTime()
        }
    },
    countWaitTime() {
      clearInterval(this.waitTimer)
      this.waitTimer = setInterval(() => {
        if (this.startT <= 0 ) {
          clearInterval(this.waitTimer);
          this.waitT = ""
          return;
        }
        let during = (new Date().getTime() - this.startT) / 1000;
        if (during >= 10) {
          let s = Math.floor(during % 60);
          let m = Math.floor(during / 60 % 60);
          let h = Math.floor(during / 60 / 60);
          h = h < 10 ? ("0" + h) : h;
          m = m < 10 ? ("0" + m) : m;
          s = s < 10 ? ("0" + s) : s;
          this.waitT = h + "小时" + m + "分" + s + "秒";
        } else {
          this.waitT = ""
        }
      }, 1000)
    },
    uploadSuccess(res, file) {
        setTimeout(() => {
            this.uploadLoading = false
            this.startT = 0;
            clearInterval(this.waitTimer)
            this.waitT = ''

            console.log(res, file);
            if (res.errorCode == 200) {
                this.uploadPop = false
                let fileData = {}
                try {
                  fileData = JSON.parse(res.data);
                } catch (error) {
                  console.log(error);
                  fileData = {}
                }
                if (fileData.file) {
                  this.$message({
                    showClose: true,
                    dangerouslyUseHTMLString: true,
                    type: 'success',
                    message: `<div>上传成功！点击<a href="${fileData.file}">下载表格</a>查看订单处理结果</div>`,
                    duration: 0
                  });
                } else {
                  this.$message.success('上传成功！')
                }
            } else {
                this.$message({
                  showClose: true,
                  message: res.errorMsg || '网络异常',
                  type: 'error',
                  duration: 12000
                })
            }
        }, 500)
    },
    uploadFail(err) {
        console.log(err)
        setTimeout(() => {
            this.uploadLoading = false
            this.startT = 0;
            this.waitT = ''
            clearInterval(this.waitTimer)
            this.$message.error('上传失败！')
        }, 500)
    }
  }
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  padding: 0 24px 40px;
  .search-box {
    padding: 10px 20px;
    text-align: right;
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .page-wrap {
    padding: 16px 0;
    text-align: right;
  }
  .time-list-wrap {
    padding: 40px 0 0;
    min-height: 240px;
    .no-data {
      padding: 30px 0;
      text-align: center;
    }
    .time-list {
      display: flex;
      flex-wrap: wrap;
    }
    .time-tag {
      margin: 0 15px 15px 0;
      cursor: pointer;
    }
  }
  .upload-stock {
    padding: 24px 0;
    text-align: center;
  }
  .progress-wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba($color: #ffffff, $alpha: 0.9);
   
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    .progress-bar {
        width: 400px;
        height: 30px;
        background: #ccc;
        border-radius: 6px;
        overflow: hidden;
        position: relative;
    }
    .progress-bar-inner {
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        height: 30px;
        background: #F56C6C;
        transition: width 0.5s;
    }
    .loading-wrap {
      height: 30px;
    }
    .text {
        font-size: 13px;
        color: #333;
        margin-top: 12px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/order/orderImport.vue